'use client';

import { useMemo } from 'react';
import type { Country } from '../../constants';
import { useSiteconfigService } from './useSiteconfigService';

export const useGetShippingPolicy = (country: Country) => {
  const { useGetShippingPolicies } = useSiteconfigService();
  const { data: shippingPolicies } = useGetShippingPolicies();

  const shippingPolicy = useMemo(() => {
    return shippingPolicies?.config.find((policy) => policy.countryCode === country);
  }, [shippingPolicies, country]);

  return { shippingPolicy };
};
